import React, { useState } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../common/Button";

import { compose, withState } from "recompose";

const APP_STORE_URL = "https://itunes.apple.com/us/app/top-nine-for-instagram-2017/id1188477208?mt=8";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bestnine&hl=en";

const Modal = ({ active, onClose, ...props }) => {
  if (!active) {
    return null;
  }

  return (
    <React.Fragment>
      <Overlay onClick={onClose} />
      <ModalContainer>
        <ModalContent>
          <GoToCreatorKit onClose={onClose} {...props} />
        </ModalContent>
      </ModalContainer>
    </React.Fragment>
  );
};

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
`;

const ModalContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const ModalContent = styled.div`
  max-width: 375px;
  width: 90%;
  background: white;
  border-radius: 10px;
  pointer-events: all;
`;

const GoToCreatorKit = ({
  username,
  email,
  onClose,
}) => {
  return (
    <React.Fragment>
      <Container>
        <React.Fragment>
          <Illustration
            src={"/assets/images/now-on-creatorkit.jpg"}
            resizeMode="contain"
            alt="Go to Top Nine 2020"
          />
          <Content>
            <Headline>Coming soon!</Headline>
            <Text>We're hard at work making the 2021 version of Top Nine available to you in the coming weeks, stay tuned for updates!</Text>
            <SubmitButton onClick={onClose} href="">
              OK
            </SubmitButton>
          </Content>
        </React.Fragment>
      </Container>
    </React.Fragment>
  );
};

const Container = styled.div`
  background: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 400px;
  max-width: 100%;
  overflow: hidden;
  position: relative;
`;

const Body = styled.p`
  font-size: 14px !important;
  color: #5b27d4;
`;

const Content = styled.div`
  padding: 24px 16px 8px 16px;
`;

const Headline = styled.h3`
  text-align: center;
  margin: 0px auto;
  margin-bottom: 1em;
  font-size: 20px;
`;

const Text = styled(Body)`
  color: #889;
  margin-bottom: 8px !important;
  font-size: 14px !important;
  text-align: center;
  @media (max-height: 600px) {
    font-size: 11px !important;
  }
`;

const Illustration = styled.img`
  width: 100%;

  display: block;
  object-fit: contain;
`;

const SubmitButton = styled(PrimaryButton)`
  width: 100%;
  display: block;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 12px;
  background: #3e8dff;
`;

const Link = styled.div`
  cursor: pointer;
  margin-bottom: 16px;
`;

const Input = styled.input`
  flex: 1;
  border: 1px solid #d3d0db;
  border-radius: 6px;
  color: #2b1755;
  width: 100%;

  margin-top: 16px;
  margin-bottom: 20px;

  font-family: Montserrat;
  font-size: 15px;
  font-weight: 700;

  height: 43px;
  display: block;
  padding: 0 20px;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #84798b;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #84798b;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #84798b;
  }
`;

const GoToTopNineButton = styled(PrimaryButton)`
  width: 100%;
  display: block;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 12px;
  background: #5b27d4;
`;

const Error = styled.p`
  color: #e94d89;
  text-align: center;
  font-size: 14px !important;
`;

export default Modal;
